module.exports = __webpack_public_path__ + "img/BCN-alt.b0c4a895.svg";